export default function WorkspaceChunkFallback() {
  return (
    <p className="muted small" role="status" aria-live="polite" data-testid="workspace-chunk-fallback">
      Memuat halaman...
    </p>
  );
}
